import { render, staticRenderFns } from "./PaginaTipologieAttivitaBanco.vue?vue&type=template&id=84b389e8&"
import script from "./PaginaTipologieAttivitaBanco.vue?vue&type=script&lang=js&"
export * from "./PaginaTipologieAttivitaBanco.vue?vue&type=script&lang=js&"
import style0 from "./PaginaTipologieAttivitaBanco.vue?vue&type=style&index=0&id=84b389e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports